import unblockCancelTripMessagesModule from "./unblockCancelTripMessagesModule"
import server from "../server"

unblockCancelTripMessagesModule.service("unblockCancelTripMessagesService", ["$http", function searchService($http) {

    this.filter = (template, firstResult, maxResults) => {
        return $http.post(server.getServiceUrl("search.unblockCancelTripMessages") + "presentation-tree", template, {
            params: {
                firstResult,
                maxResults
            }
        }).then((response) => response.data)
    }

    this.find = (recordId) => {
        return $http.get(server.getServiceUrl("unblockCancelTripMessages") + recordId)
            .then((response) => response.data)
    }

    this.forceProcessMessage = (recordId) => {
        return $http.get(server.getServiceUrl("unblockCancelTripMessages-forceProcess") + recordId)
            .then((response) => response.data)
    }
}])